module.exports = __webpack_public_path__ + "static/media/regimen-gender.bf08beb3.svg";